import React from "react";
import "./WebsiteBuilderSection.css";

const WebsiteBuilderSection = () => {
  return (
    <section className="wb-section">
      <div className="wb-container">
        <div className="wb-heading">
          <span>Website builder</span>
          <h2>Launch a professional website for your brand</h2>
          <p>
            Create landing pages, business websites, and service pages with a
            clean setup that works perfectly with your domain.
          </p>
        </div>

        <div className="wb-showcase">
          <div className="wb-preview">
            <div className="wb-bar">
              <span />
              <span />
              <span />
            </div>

            <div className="wb-hero">
              <small>yourbrand.com</small>
              <h3>Grow your business online</h3>
              <p>Domain, hosting, email, and security in one simple platform.</p>
            </div>

            <div className="wb-content-grid">
              <div />
              <div />
              <div />
            </div>
          </div>

          <div className="wb-panel">
            <span className="wb-panel-tag">Quick setup</span>
            <h3>Design faster</h3>
            <ul>
              <li>Ready sections for business pages</li>
              <li>Mobile-friendly layout system</li>
              <li>Connect domain and go live</li>
            </ul>
            <button type="button">Start building</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteBuilderSection;